export * from './sorting-table.component';